import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckboxCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#checkbox-check_svg__a)">
      <path d="M18.16 22H5.84C3.72 22 2 20.28 2 18.16V5.84C2 3.72 3.72 2 5.84 2h12.32C20.28 2 22 3.72 22 5.84v12.32c0 2.12-1.72 3.84-3.84 3.84M5.84 4C4.82 4 4 4.83 4 5.84v12.32C4 19.18 4.83 20 5.84 20h12.32c1.02 0 1.84-.83 1.84-1.84V5.84C20 4.82 19.17 4 18.16 4z" />
      <path d="M11 17c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47z" />
    </g>
    <defs>
      <clipPath id="checkbox-check_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckboxCheck;
